import Icon from '@ant-design/icons'
import { colours } from '@headbox-ui/themes'
import { Menu } from 'antd'
import React, { useEffect, useState, FC } from 'react'
import * as icons from '../Icons'
import Notifications from './Notifications'
import './styles.less'

const { grey } = colours
const headboxRed = '#AF231C'

const Link: FC<{
  href: string
  icon?: string
  target?: string
  title: string
  notificationCount?: number
}> = ({ href, icon, target, title, notificationCount }) => {
  const [inFocus, setInFocus] = useState<boolean>(window.location.href.includes(href))

  useEffect(() => {
    setInFocus(window.location.href.includes(href))
  }, [href])

  return (
    <a
      onMouseEnter={() => setInFocus(true)}
      onMouseLeave={() => setInFocus(window.location.href.includes(href))}
      style={{ ...(inFocus && { color: headboxRed }) }}
      {...{ href, target }}
    >
      {icon !== undefined && (
        <Icon
          style={{ transform: 'translateY(1px)' }}
          component={() => {
            const CustomIcon = icons[icon]
            return <CustomIcon fill={inFocus ? headboxRed : grey[500]} />
          }}
        />
      )}
      {title}
      { (notificationCount !== undefined && notificationCount > 0) && <Notifications notificationCount={notificationCount}/>}
    </a>
  )
}

const MenuItem: FC<{
  href: string
  icon?: string
  target?: string
  title: string
  notificationCount?: number
}> = ({ href, icon, target, title, notificationCount }, index): JSX.Element => (
  <Menu.Item key={index} className="menuItem">
    <Link {...{ href, icon, target, title, notificationCount }} />
  </Menu.Item>
)

export default MenuItem
